export default ({request}) => ({
  changeOrderGoodsPackageSizeListApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageSize/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageSizeDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageSize/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageSizeAddSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageSize/add/save',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageSizeEditSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageSize/edit/save',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageSizeDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageSize/del',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocListApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDoc/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDoc/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDoc/batchDel',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocUpdateApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDoc/update',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDoc/batchUpload',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocGoodsListApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDocGoods/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocGoodsBatchAddApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDocGoods/batchAdd',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDocGoodsBatchDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderGoodsPackageDocGoods/batchDel',
      method: 'post',
      data,
    })
  },
})
